// Dashboard Widget System Types

export type WidgetCategory = 'kpi' | 'chart' | 'list' | 'calendar';

export interface WidgetLayout {
  i: string;
  type: string;
  x: number;
  y: number;
  w: number;
  h: number;
  config: Record<string, any>;
}

export interface DashboardLayout {
  version: number;
  widgets: WidgetLayout[];
}

export interface DashboardData {
  id: number;
  name: string;
  description?: string;
  dashboard_type: string;
  layout: DashboardLayout;
  filters: Record<string, any>;
  is_default: boolean;
  is_public: boolean;
  created_at: string;
  updated_at: string;
}

export interface WidgetProps {
  data: any;
  config: Record<string, any>;
  loading: boolean;
  error: string | null;
  width: number;
  height: number;
  onNavigate?: (path: string) => void;
}

export interface WidgetDefinition {
  type: string;
  category: WidgetCategory;
  name: string;
  description: string;
  icon: string;
  defaultSize: { w: number; h: number };
  minSize: { w: number; h: number };
  maxSize?: { w: number; h: number };
  defaultConfig: Record<string, any>;
}

export const DEFAULT_LAYOUT: DashboardLayout = {
  version: 1,
  widgets: [
    { i: 'w1', type: 'kpi_deals_value', x: 0, y: 0, w: 3, h: 2, config: { color: 'indigo' } },
    { i: 'w2', type: 'kpi_conversations', x: 3, y: 0, w: 3, h: 2, config: { color: 'green' } },
    { i: 'w3', type: 'kpi_pending_tasks', x: 6, y: 0, w: 3, h: 2, config: { color: 'yellow' } },
    { i: 'w4', type: 'kpi_overdue_tasks', x: 9, y: 0, w: 3, h: 2, config: { color: 'red' } },
    { i: 'w5', type: 'list_recent_activities', x: 0, y: 2, w: 6, h: 4, config: { limit: 5 } },
    { i: 'w6', type: 'list_recent_deals', x: 6, y: 2, w: 6, h: 4, config: { limit: 5 } },
    { i: 'w7', type: 'list_recent_conversations', x: 0, y: 6, w: 6, h: 4, config: { limit: 5 } },
  ],
};
